module.exports = __webpack_public_path__ + "img/IMG_1962_P_FoamcoreMatted.17b2c1b3.jpg";